import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    attachment: { id: 'lblIconAttachment', defaultMessage: 'Attachment' },
});

const AttachmentIcon = React.memo(function AttachmentIcon(props: TAttachmentIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.attachment)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.841 4.252a2.25 2.25 0 0 0-3.182 0l-7.425 7.424a3.75 3.75 0 1 0 5.304 5.304l6.46-6.46a.75.75 0 1 1 1.06 1.06l-6.46 6.46a5.25 5.25 0 1 1-7.424-7.424l7.424-7.425a3.75 3.75 0 0 1 5.304 5.303l-7.618 7.618a2.25 2.25 0 0 1-3.182-3.182l6.653-6.653a.75.75 0 0 1 1.061 1.06L7.163 13.99a.75.75 0 0 0 1.06 1.061l7.618-7.617a2.25 2.25 0 0 0 0-3.182Z"
            />
        </IconBase>
    );
});

export default AttachmentIcon;

// #region Types

export type TAttachmentIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <AttachmentIcon /> : { ...IconBaseExample, render: AttachmentIcon };

// #endregion
